import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function MasterPackSection() {
  const comparison = [{
    sit: 'Tu hijo no quiere hacer los ejercicios',
    sin: 'Resistencia. Material que no se usa.',
    con: '30 Cartas de Conexión que no parecen tarea'
  }, {
    sit: 'No sabés cómo presentar el material',
    sin: 'Lo planteás como tarea y se cierra',
    con: 'Guía de Baja Fricción — cómo presentarlo sin resistencia'
  }, {
    sit: 'Primera semana bien, segunda desaparece',
    sin: 'El material queda guardado',
    con: 'Sistema de 30 días con herramientas diarias'
  }, {
    sit: 'Crisis emocional y no recordás qué hacer',
    sin: 'Buscás en el material bajo presión',
    con: 'Scripts de Bolsillo — respuesta inmediata'
  }, {
    sit: 'Querés gamificar el proceso',
    sin: 'Sin sistema de incentivos',
    con: 'Token System con fichas recortables'
  }, {
    sit: 'Querés medir si hay avance real',
    sin: 'No tenés evidencia visible',
    con: 'Mural de Logros Invisibles con pins de avance'
  }];
  const includes = ['30 Cartas de Conexión — preguntas icebreakers para el auto o la cena', '15 Cartas de Validación Flash — notas para dejar en mochila o espejo', '10 Retos de 1 Minuto — micro-mindfulness sin resistencia', '8 Misiones de Autonomía — desafíos semanales de bajo riesgo', 'Token System completo con fichas recortables', 'Scripts de Bolsillo para las 5 excusas más comunes', 'Scripts de Crisis para las 5 situaciones más difíciles', 'Mural de Logros Invisibles — tracker visual de avance', 'Bitácora de Co-Regulación para el adulto', 'Juego de las Emociones — 20 tarjetas para toda la familia', 'Plan completo de 30 días calendario día a día', 'Certificado de Compromiso Familiar'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-162">
            🕊️ ¿QUÉ AGREGA EL MASTER-PACK ACCIÓN INMEDIATA?
          </h2>
          <p className="text-xl text-gold-400 font-medium" data-id="element-163">
            El MegaPack te da el mapa. El Master-Pack te da el vehículo para
            llegar.
          </p>
        </motion.div>

        {/* Header labels — mobile stacked, desktop hidden (shown in table) */}
        <div className="md:hidden bg-navy-800 border border-navy-700 rounded-2xl p-5 mb-4 text-center" data-id="element-164">
          <div className="flex items-center justify-center gap-2 text-red-400 font-bold text-lg mb-3" data-id="element-165">
            ❌ Sin Master-Pack
          </div>
          <div className="flex items-center justify-center gap-2 text-green-400 font-bold text-lg" data-id="element-166">
            ✅ Con Master-Pack
          </div>
        </div>

        {/* Desktop Table — hidden on mobile */}
        <div className="hidden md:block mb-16" data-id="element-167">
          <table className="w-full text-left border-collapse" data-id="element-168">
            <thead data-id="element-169">
              <tr className="border-b-2 border-navy-700" data-id="element-170">
                <th className="p-4 text-slate-300 font-semibold w-1/3" data-id="element-171">
                  Situación real
                </th>
                <th className="p-4 text-red-400 font-semibold w-1/3" data-id="element-172">
                  ❌ Sin Master-Pack
                </th>
                <th className="p-4 text-green-400 font-semibold w-1/3" data-id="element-173">
                  ✅ Con Master-Pack
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-navy-800" data-id="element-174">
              {comparison.map((row, i) => <tr key={i} className="hover:bg-navy-800/50 transition-colors" data-id="element-175">
                  <td className="p-4 text-white font-medium" data-id="element-176">{row.sit}</td>
                  <td className="p-4 text-slate-400" data-id="element-177">{row.sin}</td>
                  <td className="p-4 text-gold-300 font-medium bg-gold-500/5" data-id="element-178">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards — stacked vertically, no horizontal scroll */}
        <div className="md:hidden space-y-4 mb-16" data-id="element-179">
          {comparison.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden" data-id="element-180">
              {/* Situación */}
              <div className="px-5 py-4 border-b border-navy-700/50 border-l-4 border-l-blue-500" data-id="element-181">
                <p className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-182">
                  Situación:
                </p>
                <p className="text-white font-medium text-base leading-snug" data-id="element-183">
                  {row.sit}
                </p>
              </div>

              {/* Sin Master-Pack */}
              <div className="px-5 py-4 border-b border-navy-700/50 border-l-4 border-l-red-500/70 bg-red-500/5" data-id="element-184">
                <p className="text-xs font-bold text-red-400 uppercase tracking-wider mb-1" data-id="element-185">
                  ❌ Sin Master-Pack:
                </p>
                <p className="text-slate-400 text-base leading-snug" data-id="element-186">
                  {row.sin}
                </p>
              </div>

              {/* Con Master-Pack */}
              <div className="px-5 py-4 border-l-4 border-l-green-500/70 bg-green-500/5" data-id="element-187">
                <p className="text-xs font-bold text-green-400 uppercase tracking-wider mb-1" data-id="element-188">
                  ✅ Con Master-Pack:
                </p>
                <p className="text-gold-300 font-medium text-base leading-snug" data-id="element-189">
                  {row.con}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Includes List */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-190">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 flex items-center gap-3" data-id="element-191">
            <CheckCircle2 className="w-7 h-7 md:w-8 md:h-8 text-green-500 flex-shrink-0" data-id="element-192" />
            EL MASTER-PACK INCLUYE:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4" data-id="element-193">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-194">
                <div className="w-2 h-2 rounded-full bg-gold-500 mt-2 flex-shrink-0" data-id="element-195" />
                <span className="text-slate-200 text-sm md:text-base" data-id="element-196">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}